const ViewBill = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      Thank You for making a purchase with Trendy Sarees!
    </div>
  );
};

export default ViewBill;
